import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SpinEventManager = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingEvent, setEditingEvent] = useState(null);
  const [formData, setFormData] = useState({
    title: 'Büyük Ödüllü Çevrim Etkinliği',
    prizeAmount: '3,000.00$',
    buttonText: 'Hemen Oyna',
    buttonLink: '',
    rulesButtonText: 'Kurallar Ve Detaylar',
    rulesButtonLink: '',
    startDateUtc: '',
    endDateUtc: '',
    googleSheetsUrl: '',
    isActive: true
  });
  const [logoFile, setLogoFile] = useState(null);
  const [backgroundImageFile, setBackgroundImageFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [backgroundPreview, setBackgroundPreview] = useState(null);
  const [saving, setSaving] = useState(false);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [showImageGallery, setShowImageGallery] = useState(false);
  const [showBackgroundGallery, setShowBackgroundGallery] = useState(false);

  useEffect(() => {
    fetchEvents();
    fetchUploadedImages();
  }, []);

  const fetchEvents = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/spin-events/admin/all', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEvents(response.data);
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchUploadedImages = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.get('/api/games/images', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUploadedImages(response.data || []);
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem('adminToken');
      const formDataToSend = new FormData();
      
      Object.keys(formData).forEach(key => {
        if (key !== 'logo' && key !== 'backgroundImage') {
          formDataToSend.append(key, formData[key]);
        }
      });

      // Logo: önce dosya varsa onu gönder, yoksa preview URL'ini gönder
      if (logoFile) {
        formDataToSend.append('logo', logoFile);
      } else if (logoPreview && logoPreview.startsWith('/uploads/')) {
        // Galeriden seçilen logo URL'ini gönder
        formDataToSend.append('logoUrl', logoPreview);
      }

      // Background Image: önce dosya varsa onu gönder, yoksa preview URL'ini gönder
      if (backgroundImageFile) {
        formDataToSend.append('backgroundImage', backgroundImageFile);
      } else if (backgroundPreview && backgroundPreview.startsWith('/uploads/')) {
        // Galeriden seçilen background URL'ini gönder
        formDataToSend.append('backgroundImageUrl', backgroundPreview);
      }

      let response;
      if (editingEvent) {
        response = await axios.put(
          `/api/spin-events/admin/${editingEvent.id}`,
          formDataToSend,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
      } else {
        response = await axios.post(
          '/api/spin-events/admin',
          formDataToSend,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data'
            }
          }
        );
      }

      setEvents([response.data, ...events.filter(e => e.id !== response.data.id)]);
      resetForm();
      alert('Etkinlik kaydedildi!');
    } catch (error) {
      console.error('Error saving event:', error);
      alert('Etkinlik kaydedilirken bir hata oluştu');
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (event) => {
    setEditingEvent(event);
    setFormData({
      title: event.title || 'Büyük Ödüllü Çevrim Etkinliği',
      prizeAmount: event.prizeAmount || event.prize_amount || '3,000.00$',
      buttonText: event.buttonText || event.button_text || 'Hemen Oyna',
      buttonLink: event.buttonLink || event.button_link || '',
      rulesButtonText: event.rulesButtonText || event.rules_button_text || 'Kurallar Ve Detaylar',
      rulesButtonLink: event.rulesButtonLink || event.rules_button_link || '',
      startDateUtc: event.startDateUtc || event.start_date_utc ? new Date(event.startDateUtc || event.start_date_utc).toISOString().slice(0, 16) : '',
      endDateUtc: event.endDateUtc || event.end_date_utc ? new Date(event.endDateUtc || event.end_date_utc).toISOString().slice(0, 16) : '',
      googleSheetsUrl: event.googleSheetsUrl || event.google_sheets_url || '',
      isActive: event.isActive !== undefined ? event.isActive : (event.is_active !== undefined ? event.is_active : true)
    });
    setLogoPreview(event.logoUrl || event.logo_url || null);
    setBackgroundPreview(event.backgroundImageUrl || event.background_image_url || null);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu etkinliği silmek istediğinize emin misiniz?')) {
      return;
    }

    try {
      const token = localStorage.getItem('adminToken');
      await axios.delete(`/api/spin-events/admin/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEvents(events.filter(e => e.id !== id));
      alert('Etkinlik silindi!');
    } catch (error) {
      console.error('Error deleting event:', error);
      alert('Etkinlik silinirken bir hata oluştu');
    }
  };

  const resetForm = () => {
    setEditingEvent(null);
    setFormData({
      title: 'Büyük Ödüllü Çevrim Etkinliği',
      prizeAmount: '3,000.00$',
      buttonText: 'Hemen Oyna',
      buttonLink: '',
      rulesButtonText: 'Kurallar Ve Detaylar',
      rulesButtonLink: '',
      startDateUtc: '',
      endDateUtc: '',
      googleSheetsUrl: '',
      isActive: true
    });
    setLogoFile(null);
    setBackgroundImageFile(null);
    setLogoPreview(null);
    setBackgroundPreview(null);
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBackgroundChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBackgroundImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setBackgroundPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const selectImageFromGallery = (imageUrl, type) => {
    if (type === 'logo') {
      setLogoPreview(imageUrl);
      setLogoFile(null);
    } else {
      setBackgroundPreview(imageUrl);
      setBackgroundImageFile(null);
    }
    if (type === 'logo') {
      setShowImageGallery(false);
    } else {
      setShowBackgroundGallery(false);
    }
  };

  if (loading) {
    return <div className="text-white">Yükleniyor...</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-3xl font-bold text-gold">Çevrim Etkinliği Yönetimi</h2>
        <button
          onClick={resetForm}
          className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-6 py-2 rounded-lg transition-all"
        >
          Yeni Etkinlik Ekle
        </button>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="bg-gradient-card rounded-xl p-6 border border-gold/30 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-white mb-2">Başlık</label>
            <input
              type="text"
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2">Ödül Miktarı</label>
            <input
              type="text"
              value={formData.prizeAmount}
              onChange={(e) => setFormData({ ...formData, prizeAmount: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              placeholder="3,000.00$"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-white mb-2">Logo</label>
            <div className="flex gap-2">
              <input
                type="file"
                accept="image/*"
                onChange={handleLogoChange}
                className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              />
              <button
                type="button"
                onClick={() => setShowImageGallery(true)}
                className="bg-navy-600 hover:bg-navy-500 text-white px-4 py-2 rounded-lg"
              >
                Galeri
              </button>
            </div>
            {logoPreview && (
              <img src={logoPreview} alt="Logo preview" className="mt-2 h-24 object-contain" />
            )}
          </div>

          <div>
            <label className="block text-white mb-2">Arka Plan Fotoğrafı</label>
            <div className="flex gap-2">
              <input
                type="file"
                accept="image/*"
                onChange={handleBackgroundChange}
                className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              />
              <button
                type="button"
                onClick={() => setShowBackgroundGallery(true)}
                className="bg-navy-600 hover:bg-navy-500 text-white px-4 py-2 rounded-lg"
              >
                Galeri
              </button>
            </div>
            {backgroundPreview && (
              <img src={backgroundPreview} alt="Background preview" className="mt-2 h-32 w-full object-cover rounded" />
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-white mb-2">Buton Metni</label>
            <input
              type="text"
              value={formData.buttonText}
              onChange={(e) => setFormData({ ...formData, buttonText: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Buton Link</label>
            <input
              type="url"
              value={formData.buttonLink}
              onChange={(e) => setFormData({ ...formData, buttonLink: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-white mb-2">Kurallar Butonu Metni</label>
            <input
              type="text"
              value={formData.rulesButtonText}
              onChange={(e) => setFormData({ ...formData, rulesButtonText: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
            />
          </div>

          <div>
            <label className="block text-white mb-2">Kurallar Butonu Link</label>
            <input
              type="url"
              value={formData.rulesButtonLink}
              onChange={(e) => setFormData({ ...formData, rulesButtonLink: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-white mb-2">Başlangıç Tarihi (UTC)</label>
            <input
              type="datetime-local"
              value={formData.startDateUtc}
              onChange={(e) => setFormData({ ...formData, startDateUtc: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              required
            />
          </div>

          <div>
            <label className="block text-white mb-2">Bitiş Tarihi (UTC)</label>
            <input
              type="datetime-local"
              value={formData.endDateUtc}
              onChange={(e) => setFormData({ ...formData, endDateUtc: e.target.value })}
              className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-white mb-2">Google Sheets URL</label>
          <input
            type="url"
            value={formData.googleSheetsUrl}
            onChange={(e) => setFormData({ ...formData, googleSheetsUrl: e.target.value })}
            className="w-full px-4 py-2 bg-navy-700 border border-gold/30 rounded-lg text-white focus:outline-none focus:border-gold"
            placeholder="https://docs.google.com/spreadsheets/d/..."
          />
        </div>

        <div className="flex items-center gap-4">
          <label className="flex items-center gap-2 text-white">
            <input
              type="checkbox"
              checked={formData.isActive}
              onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
              className="w-5 h-5"
            />
            <span>Aktif</span>
          </label>
        </div>

        <div className="flex gap-4">
          <button
            type="submit"
            disabled={saving}
            className="bg-gradient-to-r from-gold to-yellow-500 hover:from-yellow-500 hover:to-gold text-navy-900 font-bold px-6 py-2 rounded-lg transition-all disabled:opacity-50"
          >
            {saving ? 'Kaydediliyor...' : editingEvent ? 'Güncelle' : 'Kaydet'}
          </button>
          {editingEvent && (
            <button
              type="button"
              onClick={resetForm}
              className="bg-navy-600 hover:bg-navy-500 text-white px-6 py-2 rounded-lg"
            >
              İptal
            </button>
          )}
        </div>
      </form>

      {/* Events List */}
      <div className="bg-gradient-card rounded-xl p-6 border border-gold/30">
        <h3 className="text-2xl font-bold text-gold mb-4">Etkinlikler</h3>
        <div className="space-y-4">
          {events.map((event) => (
            <div
              key={event.id}
              className="bg-navy-700 rounded-lg p-4 border border-gold/20 flex justify-between items-center"
            >
              <div>
                <h4 className="text-white font-bold">{event.title || event.prizeAmount || event.prize_amount}</h4>
                <p className="text-white/70 text-sm">
                  {new Date(event.startDateUtc || event.start_date_utc).toLocaleDateString('tr-TR')} -{' '}
                  {new Date(event.endDateUtc || event.end_date_utc).toLocaleDateString('tr-TR')}
                </p>
                <span className={`inline-block px-2 py-1 rounded text-xs ${
                  event.isActive || event.is_active
                    ? 'bg-green-500 text-white'
                    : 'bg-red-500 text-white'
                }`}>
                  {event.isActive || event.is_active ? 'Aktif' : 'Pasif'}
                </span>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => handleEdit(event)}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  Düzenle
                </button>
                <button
                  onClick={() => handleDelete(event.id)}
                  className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg"
                >
                  Sil
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Gallery Modal */}
      {(showImageGallery || showBackgroundGallery) && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="bg-navy-800 rounded-xl p-6 max-w-4xl w-full max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-2xl font-bold text-gold">Görsel Galerisi</h3>
              <button
                onClick={() => {
                  setShowImageGallery(false);
                  setShowBackgroundGallery(false);
                }}
                className="text-white hover:text-gold"
              >
                ✕
              </button>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {uploadedImages.map((image) => (
                <div
                  key={image}
                  className="cursor-pointer border-2 border-transparent hover:border-gold rounded-lg overflow-hidden"
                  onClick={() => selectImageFromGallery(image, showImageGallery ? 'logo' : 'background')}
                >
                  <img
                    src={image}
                    alt="Gallery"
                    className="w-full h-32 object-cover"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpinEventManager;
